
import { Component, Prop, Vue } from 'vue-property-decorator';
import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { schedule5DataInfoType } from '@/types/Application/ReplyFamilyLawMatter/Pdf';
import NoteBox from '@/components/utils/PopulateForms/components/NoteBox.vue';
import FormPart from '@/components/utils/PopulateForms/components/FormPart.vue';
import ScheduleHeader from '@/components/utils/PopulateForms/components/ScheduleHeader.vue';
import GreyBoxForm from '@/components/utils/PopulateForms/components/GreyBoxForm.vue';

@Component({
    components:{
        UnderlineForm,
        CheckBox,
        NoteBox,
        FormPart,
        ScheduleHeader,
        GreyBoxForm
    }
})
export default class Schedule5 extends Vue {

    @Prop({required:true})
    result!: any;
    
    dataReady = false;
    chContInfo = {} as schedule5DataInfoType;   
   
    mounted(){
        this.dataReady = false;   
        this.extractInfo();       
        this.dataReady = true;        
    }

    public extractInfo(){ 
        console.log(this.result)
        this.chContInfo = this.getNewChildContactInfo();
    }   

    public getNewChildContactInfo(){

        let newChildContactInfo = {} as schedule5DataInfoType;  
        
        newChildContactInfo.abt = {
            conType: {
                noContact: false,
                inPerson: false,
                tel: false,
                video: false,
                written:false,
                other: false
            },
            inPrsn: '',
            otherComm: '',
            cond: ''            
        };
        newChildContactInfo.bstIntrst = '';

        if (this.result.disagreeContactWithChildSurvey){
            const disagreeInfo = this.result.disagreeContactWithChildSurvey;
            const contactChoices = disagreeInfo.contactTypeChoices?disagreeInfo.contactTypeChoices:[];
            newChildContactInfo.abt = {
                conType: {
                    noContact: contactChoices.includes('No contact of any type'),
                    inPerson: contactChoices.includes('In person'),
                    tel: contactChoices.includes('Telephone communication'),
                    video: contactChoices.includes('Video communication'),
                    written:contactChoices.includes('Written communication'),
                    other: contactChoices.includes('other')
                },
                inPrsn: (contactChoices.includes('In person'))? disagreeInfo.inPersonDetails:'',
                otherComm: (contactChoices.includes('other'))? disagreeInfo.contactTypeChoicesComment:'',
                cond: (disagreeInfo.placeConditions == 'y')? disagreeInfo.conditionsDescription:''                
            }
            newChildContactInfo.bstIntrst = disagreeInfo.childBestInterestReason?disagreeInfo.childBestInterestReason:'';
        }        

        return newChildContactInfo;
    }  

}
